import type { RouteObject } from 'react-router';
import { PageReclamation } from './PageReclamation';
import { PageReclamations } from './PageReclamations';
import { PageStatistiquesReclamations } from './PageStatistiquesReclamations';

export const routesReclamations: RouteObject[] = [
  { path: '/reclamations', element: <PageReclamations /> },
  { path: '/reclamations/statistiques', element: <PageStatistiquesReclamations /> },
  { path: '/reclamations/:id', element: <PageReclamation /> },
];
